import type { QueryClient } from '@tanstack/react-query';

import { useChatStore } from 'state/store/chat/use-chat-store';
import type { Project } from '../types/create-project';

export function removeProjectFromSidebarAndCache(queryClient: QueryClient, projectId: string) {
  useChatStore.getState().removeProjectFromSidebar(projectId);

  queryClient.setQueriesData<Project[]>({ queryKey: ['getProjects'] }, (old) =>
    old?.filter((project) => project.id !== projectId)
  );
  queryClient.removeQueries({ queryKey: ['getProject', projectId] });
  queryClient.removeQueries({ queryKey: ['project-conversations', projectId] });
  queryClient.invalidateQueries({ queryKey: ['getProjectsPage'] });
}

export function addProjectToSidebarAndCache(queryClient: QueryClient, project: Project) {
  const { sidebarProjectsList, setSidebarProjectsList } = useChatStore.getState();
  setSidebarProjectsList([project, ...sidebarProjectsList.filter((item) => item.id !== project.id)]);

  queryClient.setQueriesData<Project[]>({ queryKey: ['getProjects'] }, (old) =>
    old ? [project, ...old.filter((item) => item.id !== project.id)] : [project]
  );
  queryClient.invalidateQueries({ queryKey: ['getProjectsPage'] });
}
